import {IHttpResponse, IHttpService, IPromise} from "angular";
import {AccessLevelPreset} from "../../users/model/AccessLevelPreset";
import {getAbsoluteUrl} from "../../utils/urlUtill";
import {ToastNotificationServiceName} from "../../utils/names/serviceNames";
import {ToastNotificationService} from "../../utils/ToastNotificationService";

export class UserAccessLevelPresetService {

    static instance = [
        '$http',
        ToastNotificationServiceName,
        UserAccessLevelPresetService
    ]

    constructor(private $http: IHttpService,
                private toastNotificationService: ToastNotificationService) {

    }

    public fetchAllPresets = ():IPromise<AccessLevelPreset[]> => {
        return this.$http({
            method: 'GET',
            url: getAbsoluteUrl('api/users/feature-access/preset')
        }).then((resp: IHttpResponse<AccessLevelPreset[]>) => {
            if (resp.status === 200) {
                return resp.data;
            } else {
                this.toastNotificationService.generateErrorMessage('failed to fetch access level presets');
            }
        })
    }

}